import { Box } from '@mui/material';
import { AdviseSupplier } from '../../../../types/advise';
import { SupplierRoiResult } from './RoiAnalysisPanel.calc';
import { RoiSummaryCard } from './RoiSummaryCard';

export interface RoiSummaryCardsProps {
  suppliers: AdviseSupplier[];
  results: Record<string, SupplierRoiResult>;
}

export const RoiSummaryCards = ({ suppliers, results }: RoiSummaryCardsProps) => (
  <Box className="grid grid-cols-1 md:grid-cols-3 gap-3">
    {suppliers.map(
      (supplier) =>
        results[supplier.id] && (
          <RoiSummaryCard
            key={supplier.id}
            supplier={supplier}
            roi={results[supplier.id]}
          />
        )
    )}
  </Box>
);
